export default __webpack_public_path__ + "static/media/contrôle.c46d18a6.svg";